import { Layout } from "./Layout";
import { staticContent } from "./staticContent";

export const Registration = () => {
  return (
    <Layout {...staticContent.globalContent} {...staticContent.registration} />
  );
};
